<script setup>
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import HeaderCell from '@js/components/tables/cells/HeaderCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    filters,
    availableFilters,
    setGlobalFilter,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'email',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Email',
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.email,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'createdAt',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Créé le',
                }),
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.createdAt,
                }),
        }),
    ],
    url: route('front.projectManagement.modules.postEmailingUnsubscriptions', {
        tenant: tenant.id,
    }),
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :filters="filters"
        :available-filters="availableFilters"
        :set-filters="setFilters"
        :set-global-filter="setGlobalFilter"
        :loading="loading"
    />
</template>
